<template>
  <el-select
      :disabled="disabled"
      size="small"
      v-model="selectedMember"
      :placeholder="$t('common.please.select')"
      style="width: 300px"
      @change="handleChange"
      filterable
      multiple
      collapse-tags
      collapse-tags-tooltip
      allow-create
      :reserve-keyword="false"
      :max-collapse-tags="collapseTagNumber"
      clearable
      popper-class="sp_selectEditTag"
      @input="remoteMethod"
      @visibleChange="changeVisible"
  >
    <!--    v-select-load-more="loadMore"-->
    <el-option
        style="max-width:300px;overflow: hidden"
        v-for="item in tableData"
        :key="item.labelName"
        :label="item.labelName"
        :value="item.labelName"
        :disabled="selectedMember.includes('')"
    >
    </el-option>
    <el-option v-if="!isOnlyTagFlag" :label="$t('select.empty')" :value="''">
      <template #default>
        {{ $t('select.empty') }}
      </template>
    </el-option>
  </el-select>
</template>

<script setup>
import {computed, nextTick, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {debouncePlus, throttle} from "@/utils/mylodash";
import {i18n} from "@/lang";
import {getCustomerOrigin, getCustomerProduct, mailCustomerLabelList} from "@/api/customer";
import {ElMessage} from "element-plus";
import {sortList} from "@/utils/cache";

const emit = defineEmits(['selectChange'])
const {element, typeSelect, isShowEmpty, isOnlyTagFlag, managerId} = defineProps({
  element: {
    type: Object,
    default: () => ({})
  },
  // 1 客户来源 2.客户意向产品
  typeSelect: {
    type: Number,
    default: 0
  },
  collapseTagNumber: {
    type: Number,
    default: 1,
  },
  isShowEmpty: {
    type: Boolean,
    default: false
  },
  managerId: {
    type: String,
    default: ''
  },
  isOnlyTagFlag: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false,
  }
})

const store = useStore()
const teamId = computed(() => store.state.email.teamID)
const customerSelectData = computed(() => store.state.cusList.customerSelectData);
const userInfo = computed(() => store.state.user.userInfo)
const tableData = ref([])
const empty = ref(i18n.global.t('select.empty'))
const selectedMember = defineModel('selectedMember', {type: Array, default: () => []})

// 分页
const pageNo = ref(1)
const pageSize = ref(9999)
const total = ref(0)
// 成员信息
const loadMore = throttle(async () => {
  console.log("more")
  if (pageNo.value === Math.ceil(total.value / pageSize.value)) {
    return
  } else {
    pageNo.value++
    await getTagList()
  }
}, 300)

// 获取标签信息
const searchTarget = ref('')
const getTagList = async (targetManagerId) => {
  try {
    const payload = {
      pageNo: pageNo.value,
      pageSize: pageSize.value,
      teamId: teamId.value,
      search: searchTarget.value,
      type: 1,
      managerId: targetManagerId
    }
    // console.log(payload.managerId, !payload.managerId, 'payload.managerId', userInfo.value.id)
    if (!payload.managerId) {
      payload.managerId = userInfo.value.id;
    }
    if (payload.managerId === 'all') {
      payload.managerId = ''
    }

    let requestAPI = null
    if (!isOnlyTagFlag) {
      // 全部整合标签
      if (typeSelect === 1) {
        requestAPI = getCustomerOrigin
      } else {
        requestAPI = getCustomerProduct
      }
    } else {
      // 只有 预设标签
      payload.labelType = typeSelect
      requestAPI = mailCustomerLabelList
    }
    const res = await requestAPI(payload)
    let newRecords = []
    if (!isOnlyTagFlag) {
      newRecords = res?.result?.records.map(item => ({labelName: item})) || []
    } else {
      newRecords = res.result?.records.map(item => ({labelName: item.labelName})) || []
    }

    // 如果是第一页 => 覆盖，否则 => 追加
    if (pageNo.value === 1) {
      tableData.value = newRecords.filter(item => item.labelName !== '')
    } else {
      tableData.value = [...tableData.value, ...newRecords].filter(item => item.labelName !== '')
    }
    console.log(tableData.value, 'sortList')
    tableData.value = sortList(tableData.value)

    pageNo.value = res.result.current;
    pageSize.value = res.result.size;
    total.value = res.result.total;
  } catch (e) {
    ElMessage.error(e)
  }
}

const changeVisible = async () => {
  if (searchTarget.value !== '') {
    searchTarget.value = '';
    pageNo.value = 1;
    await getTagList()
  }
  const wrappers = document.querySelectorAll('.sp_selectEditTag .el-select-dropdown .el-select-dropdown__wrap');
  console.log(wrappers, 'selectWrapper_changeVisible')
  await nextTick()
  // setTimeout(() => {
  // selectWrapper?.addEventListener("scroll", async () => {
  //   await loadMore()
  // })
  wrappers.forEach(w => w.addEventListener('scroll', loadMore))
  // }, 100)
}

const remoteMethod = debouncePlus(async (search) => {
  console.log(search.target.value, 'search.data')
  searchTarget.value = search.target.value
  await getTagList()
}, 300)

// const handleChange = async (val) => {
//   console.log(val, 'search.data')
//   // 重置
//   if (searchTarget.value !== "") {
//     searchTarget.value = ''
//     await getTagList()
//   }
//   emit('update:selectedMember', val)
// }

const handleChange = async (val) => {
  console.log(val, 'search.data')

  // 互斥逻辑：如果选择了 empty（value=""）
  if (val.includes("")) {
    // 如果用户点了 ""，则只保留 ""
    val = [""]
    emit('update:selectedMember', val)
    return
  }

  // 如果之前已经选了 ""，现在选了其他项，则移除 ""（保持互斥）
  const emptyIndex = val.indexOf("")
  if (emptyIndex !== -1 && val.length > 1) {
    val.splice(emptyIndex, 1)
  }

  /** --------------------------
   *  以下是你原来的逻辑
   * -------------------------**/
  if (searchTarget.value !== "") {
    searchTarget.value = ''
    await getTagList()
  }

  emit('update:selectedMember', val)
}

onMounted(async () => {
  await getTagList()
})

defineExpose({
  selectedMember,
  getTagList,
})
</script>